import styles from "../../styles/Error/ErrorPopup.module.css";
import React, { useEffect } from 'react';

export const ErrorPopup = ({ message }) => {
  return (
    <div className={styles.errorPopup}>
      {message}
    </div>
  );
};

